import type { ReactNode } from 'react';
import { Check } from 'lucide-react';

/** A numbered step of a stage's "À faire" view: done, still to do, or optional (null). */
export interface StepMark { n: number; done: boolean | null }

// One block of the project page, the same everywhere (Aperçu, every topic
// tab, the stage's "À faire" view, the task page): a white card with a header
// row — title left, actions right — and its content below. `flush` drops the
// body padding for lists whose rows run edge to edge (milestones,
// deliverables). `step` numbers the card as a step of the stage's work.
export function ProjectSection({ title, actions, children, id, flush, step }: {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  id?: string;
  flush?: boolean;
  step?: StepMark;
}) {
  return (
    <section className={`pd-card${step ? ' pd-card--step' : ''}`} id={id}>
      <header className="pd-card-head">
        <h3 className="pd-card-title">
          {step && <StepBadge step={step} />}
          {title}
        </h3>
        {actions && <div className="pd-card-actions">{actions}</div>}
      </header>
      <div className={`pd-card-body${flush ? ' pd-card-body--flush' : ''}`}>{children}</div>
    </section>
  );
}

export function StepBadge({ step }: { step: StepMark }) {
  const state = step.done === true ? 'done' : step.done === false ? 'todo' : 'opt';
  return (
    <span className={`pd-step pd-step--${state}`} aria-hidden>
      {step.done === true ? <Check size={11} strokeWidth={3} /> : step.n}
    </span>
  );
}
